import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { LocationStateFrom } from '../types'

export const useUrlFrom = () => {
    const state = useLocation().state as LocationStateFrom
    return useMemo( () => state?.from, [ state ] )
}